import React from "react";
import { Box, MenuItem, Typography, Menu, TextField } from "@mui/material";
import Field from "../Field/Fi";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import useMediaQuery from "@mui/material/useMediaQuery";

const years = ["2000", "2001", "2002", "2003", "2004", "2005"];

function YearSelect({ resetFilter, disabled = false }) {
  const tabMatch = useMediaQuery("(max-width:900px)");

  const [yearVal, setYearVal] = React.useState("");
  const [minYear, setMinYear] = React.useState("");
  const [maxYear, setMaxYear] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    if (resetFilter) {
      resetYear();
    }
  }, [resetFilter]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const resetYear = () => {
    setMinYear("");
    setMaxYear("");
    setYearVal("");
  };

  const handleMinYear = ({ target }) => {
    const value = target.value;
    setMinYear(value);
    setYearVal(value + "-");
  };

  const handleMaxYear = ({ target }) => {
    const value = target.value;
    setMaxYear(value);
    setYearVal(minYear + "-" + value);
  };

  const isFilled = () => {
    return minYear.length > 0;
  };

  return (
    <>
      <TextField
        disabled={disabled}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        variant="outlined"
        value={yearVal}
        sx={{
          width: { sm: "17.6%", lg: "130px" },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: isFilled() && !isFocused && "primary.main",
            },
          },
        }}
        label={
          isFilled() ? (
            ""
          ) : isFocused ? (
            "Year"
          ) : (
            <Typography
              variant="body1"
              color={disabled ? "#808080" : "#616161"}
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
            >
              Year
            </Typography>
          )
        }
        inputProps={{
          style: {
            borderRadius: "3px",
            lineHeight: "20px",
            fontWeight: "400",
            fontSize: "14px",
            caretColor: "transparent",
          },
        }}
        InputLabelProps={{
          sx: {
            transform:
              !isFocused &&
              (tabMatch ? "translate(7px,9px)" : "translate(13px,11.14px)"),
          },
        }}
        InputProps={{
          endAdornment: isFocused ? (
            <KeyboardArrowUpIcon
              sx={{ marginRight: "-1px", color: "primary.main" }}
            />
          ) : (
            <KeyboardArrowDownIcon
              sx={{ marginRight: "-1px", color: "#808080" }}
            />
          ),
          sx: {
            backgroundColor: disabled
              ? "#F5F5F5"
              : !isFocused && isFilled() && "#E9EFFA",
            height: { sm: "38.14px", lg: "46.29px" },
            borderRadius: "4px",
          },
        }}
        id="year-button"
        aria-controls="year-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      />
      {!disabled && (
        <Menu
          id="year-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "year-button",
          }}
          sx={{ marginTop: "4px" }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <MenuItem
            disableRipple
            sx={{
              display: "flex",
              flexDirection: "column",
              margin: "0",
              padding: "0",
              paddingX: "18px",
              width: "432px",
              height: "117px",
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "white",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginY: "8px",
              }}
            >
              <Field
                value={minYear}
                handleChange={handleMinYear}
                label="Min. Year"
                height="43.19px"
                sx={{ width: "180px" }}
                select={true}
              >
                {years.map((y) => (
                  <MenuItem key={y} value={y}>
                    {y}
                  </MenuItem>
                ))}
              </Field>
              <Box
                sx={{
                  width: "16px",
                  height: "2px",
                  backgroundColor: "#BFBFBF",
                  marginX: "10px",
                }}
              ></Box>
              <Field
                value={maxYear}
                handleChange={handleMaxYear}
                label="Max. Year"
                height="43.19px"
                sx={{ width: "180px" }}
                select={true}
              >
                {years.map((y) => (
                  <MenuItem key={y} value={y}>
                    {y}
                  </MenuItem>
                ))}
              </Field>
            </Box>
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#C4C4C4",
                height: "1px",
                marginTop: "8px",
                marginBottom: "16px",
              }}
            ></Box>
            <Box sx={{ display: "flex", width: "100%", justifyContent: "end" }}>
              <Typography
                variant="body2"
                fontFamily="Roboto"
                fontWeight="400"
                fontSize="14px"
                lineHeight="20px"
                color="primary.main"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                    textDecoration: "underline",
                  },
                }}
                onClick={resetYear}
              >
                Reset
              </Typography>
            </Box>
          </MenuItem>
        </Menu>
      )}
    </>
  );
}

export default YearSelect;
